// Number of saved albums retrieved from Spotify in order to check if there are any new saved album
export const CHECK_NEW_ALBUMS_BLOCK_LENGTH = 3;

export const NOT_SET_VALUE = "";

export const DEFAULT_YES_NO_OPTIONS = {
    [NOT_SET_VALUE]: {
        name: "Not set"
    },
    [true]: {
        name: "Yes"
    },
    [false]: {
        name: "No"
    }
}

// #region Album list page size

export const DEFAULT_DETAILED_ALBUM_LIST_PAGE_SIZE = 36;
export const DEFAULT_SQUARED_ALBUM_LIST_PAGE_SIZE = 102;

export const ALBUM_LIST_PAGE_SIZE_TEXTS = {
    title: "Album list page sizes",
    description: "How many saved albums you want to be displayed in a single page of the album list? You can set different values depending on the layout selected. Type 0 to disable pagination.",
    detailedAlbumSize: {
        label: "List layout page size",
        helperText: "Type a natural number"
    },
    squaredAlbumSize: {
        label: "Grid layout page size",
        helperText: "Type a natural number"
    }
}

// #endregion Album list page size

// #region Random method

export const RANDOM_METHODS = {
    albumBlocks: 'albumBlocks',
    simple: 'simple'
};

export const DEFAULT_RANDOM_METHOD = RANDOM_METHODS.albumBlocks;

export const RANDOM_METHOD_TEXTS = {
    title: "Random algorithm",
    description: "Choose here the random algorithm that is used when choosing between your saved albums and adding them to the random queue. Every method avoids to choose an album that is already in queue.",
    albumBlocks: {
        name: "Like the old times",
        description: "With this algorithm, an album that has not been played recently is more likely to be chosen."
    },
    simple: {
        name: "The simplest",
        description: "It just chooses one album randomly, only leaving out of it the last played album."
    }
}

// #endregion Random method

// #region Random queue limit

export const DEFAULT_RANDOM_QUEUE_LENGTH = 6;
export const RANDOM_QUEUE_MIN_LENGTH = 5;
export const RANDOM_QUEUE_MAX_LENGTH = 20;

export const RANDOM_QUEUE_LENGTH_TEXTS = {
    title: "Random queue length",
    description: "How long the random album queue you want it to be.",
    helperText: `Type a natural number between ${RANDOM_QUEUE_MIN_LENGTH} and ${RANDOM_QUEUE_MAX_LENGTH}`
}

// #endregion Random queue limit

// #region Auto new random album

export const AUTO_NEW_RANDOM_ALBUM_TEXTS = {
    title: "New automatic random album",
    description: "When the random queue's end is reached, do you want a new random album to be automatically added to the queue or not?",
    [true]: {
        description: "When the last album of the random queue starts to play, a new random album will be added."
    },
    [false]: {
        description: "When the last album of the random queue starts to play, no album will be added."
    }
}

// #endregion Auto new random album

// #region Always clear queue

export const ALWAYS_CLEAR_QUEUE_TEXTS = {
    title: "Clearing Spotify's queue",
    description: "Certain operations in this app asks you if you want to clear Spotify's queue before. Do you want to automatically do this process without asking again?",
    [NOT_SET_VALUE]: {
        description: "A popup will be shown to ask you each time clearing Spotify queue is appropiate."
    },
    [true]: {
        description: "It will always clear the Spotify queue when appropiate."
    },
    [false]: {
        description: "The Spotify queue will never be automatically cleared."
    }
}

// #endregion Always clear queue

// #region Action for starting random mode

export const ACTIONS_FOR_STARTING_RANDOM_MODE = {
    start: 'start',
    startFromCurrentTrack: 'startFromCurrentTrack'
};

export const DEFAULT_ACTION_FOR_STARTING_MODE = ACTIONS_FOR_STARTING_RANDOM_MODE.start;

export const ACTION_FOR_STARTING_RANDOM_MODE_TEXTS = {
    title: "Action performed when starting random mode",
    description: "When the random mode has been stopped (or has not started yet), which action do you want to be performed when it is started?",
    start: {
        name: 'Start next random album',
        description: "The first next random album will be played from its first track."
    },
    startFromCurrentTrack: {
        name: "Start from the current track",
        description: "The currently played album will be added to the beginning of the queue (if it is not part of it yet) and the playback will continue from the currently played track."
    }
};

// #endregion Action for starting random mode

// #region Action for resuming random mode

export const ACTIONS_FOR_RESUMING_RANDOM_MODE = {
    resumeAlbum: 'resumeAlbum',
    restartAlbum: 'restartAlbum',
    resumeFromCurrentTrack: 'resumeFromCurrentTrack'
};

export const DEFAULT_ACTION_FOR_RESUMING_MODE = ACTIONS_FOR_RESUMING_RANDOM_MODE.resumeAlbum;

export const ACTION_FOR_RESUMING_RANDOM_MODE_TEXTS = {
    title: "Action performed when resuming random mode",
    description: "When the random mode has been paused, which action do you want to be performed when it is resumed?",
    resumeAlbum: {
        name: "Resuming paused album",
        description: "The last random album played will be resumed from its last played track."
    },
    restartAlbum: {
        name: "Restart paused album",
        description: "The last random album played will be restarted."
    },
    resumeFromCurrentTrack: {
        name: "Resume from current track",
        description: "The currently played album will be added to the beginning of the queue (if it is not part of it yet) and the playback will continue from the currently played track."
    }
}

// #endregion Action for resuming random mode